import React from 'react'
import withCapabilities from '../../hoc/withCapabilities'
import { Box } from '@mui/material'
import MiniDrawer from '../Header/Drawer/Drawer'
import theme, { PAGE_BOTTOM_PADDING, PAGE_MAX_WIDTH, PAGE_TOP_PADDING, PAGE_WIDTH } from '../../theme'
import { MenuItem } from '../../types/menuItem.types'
import { useAtom } from 'jotai'
import { userAtom } from '../../stores/userAtom'
import { UserRoles } from '../../types/userRoles'
import { useConfigurationWarningsForMenu } from '../../features/Configuration/hooks/useConfigurationWarningsForMenu'
import { AdminRoutes } from '../../config/routes.config'

const ManagerPageTemplate: React.FC<{
  menuItems: MenuItem[]
  children: React.ReactNode
}> = ({ menuItems, children }) => {
  const [user] = useAtom(userAtom)
  const isAdmin = user?.role === UserRoles.ADMIN
  const drawerWidth = isAdmin ? 340 : 240
  const { pricingHasWarnings, availabilityHasWarnings } = useConfigurationWarningsForMenu(isAdmin)

  const menuItemsWithWarnings = menuItems.map((menuItem) => {
    if (menuItem.url === AdminRoutes.CONFIGURATION_PRICING) {
      return { ...menuItem, showWarning: pricingHasWarnings }
    }

    if (menuItem.url === AdminRoutes.CONFIGURATION_AVAILABILITY) {
      return { ...menuItem, showWarning: availabilityHasWarnings }
    }

    return menuItem
  })

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.secondary.light,
      }}
    >
      <MiniDrawer menuItems={menuItemsWithWarnings} drawerWidth={drawerWidth}>
        <Box
          sx={{
            width: PAGE_WIDTH,
            maxWidth: PAGE_MAX_WIDTH,
            pt: PAGE_TOP_PADDING,
            pb: PAGE_BOTTOM_PADDING,
            margin: '0 auto',
            minHeight: `93vh`,
          }}
        >
          {children}
        </Box>
      </MiniDrawer>
    </Box>
  )
}

export default withCapabilities(ManagerPageTemplate)
